module.exports = __webpack_public_path__ + "img/icon_instagram_rotate.3990c620.svg";